import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import EmailFolder from "@mapmycustomers/shared/enum/EmailFolder";
import Email from "@mapmycustomers/shared/types/email/Email";
import EmailThread from "@mapmycustomers/shared/types/email/EmailThread";
import EntityEmailSync from "@mapmycustomers/shared/types/email/EntityEmailSync";
import {
  Company,
  EntitiesSupportedByEmailFeature,
  Person,
} from "@mapmycustomers/shared/types/entity";

export const initEntityEmails = createAction("@component/entityEmails/init")<{
  entity: EntitiesSupportedByEmailFeature;
}>();

export const destroyEntityEmails = createAction("@component/entityEmails/destroy")();

export const fetchEntityEmailSync = createAsyncAction(
  "@component/entityEmails/fetchEntityEmailSync/request",
  "@component/entityEmails/fetchEntityEmailSync/success",
  "@component/entityEmails/fetchEntityEmailSync/failure"
)<void, EntityEmailSync | undefined, void>();

export const dismissEntityEmailsSync = createAsyncAction(
  "@component/entityEmails/dismissEntityEmailsSync/request",
  "@component/entityEmails/dismissEntityEmailsSync/success",
  "@component/entityEmails/dismissEntityEmailsSync/failure"
)<void, void, void>();

export const setParentEmailThreadsFolder = createAction(
  "@component/entityEmails/setParentEmailThreadsFolder"
)<EmailFolder>();

export const searchParentEmailThreads = createAsyncAction(
  "@component/entityEmails/searchParentEmailThreads/request",
  "@component/entityEmails/searchParentEmailThreads/success",
  "@component/entityEmails/searchParentEmailThreads/failure"
)<
  {
    searchText: string;
  } | void,
  {
    data: EmailThread[];
    totalCount: number;
  },
  void
>();

export const loadParentEmailThreads = createAsyncAction(
  "@component/entityEmails/loadParentEmailThreads/request",
  "@component/entityEmails/loadParentEmailThreads/success",
  "@component/entityEmails/loadParentEmailThreads/failure"
)<
  void,
  {
    data: EmailThread[];
    totalCount: number;
  },
  void
>();

export const openParentEmailThread = createAction("@component/entityEmails/openParentEmailThread")<
  EmailThread["id"]
>();

export const closeParentEmailThread = createAction(
  "@component/entityEmails/closeParentEmailThread"
)();

export const loadChildEmails = createAsyncAction(
  "@component/entityEmails/loadChildEmails/request",
  "@component/entityEmails/loadChildEmails/success",
  "@component/entityEmails/loadChildEmails/failure"
)<void, Email[], void>();

export const loadSentEmail = createAsyncAction(
  "@component/entityEmails/loadSentEmail/request",
  "@component/entityEmails/loadSentEmail/success",
  "@component/entityEmails/loadSentEmail/failure"
)<
  {
    callback: () => void;
    failureCallback: () => void;
    messageId: string;
  },
  Email,
  void
>();

export const refreshParentEmailThread = createAction(
  "@component/entityEmails/refreshParentEmailThread"
)<EmailThread>();

export const relateEmailEntities = createAction("@component/entityEmails/relateEmailEntities")<{
  callback: (people: Person[]) => void;
  companies: Company[];
  failureCallback: () => void;
  people: Person[];
}>();

export const unrelateEmailEntities = createAction("@component/entityEmails/unrelateEmailEntities")<{
  callback: (people: Person[]) => void;
  companies: Company[];
  failureCallback: () => void;
  people: Person[];
}>();

export const updatePersonEmail = createAction("@component/entityEmails/updatePersonEmail")<{
  callback: (person: Person) => void;
  email: null | string;
  failureCallback: () => void;
  id: Person["id"];
}>();

export type Actions = ActionType<
  | typeof closeParentEmailThread
  | typeof destroyEntityEmails
  | typeof dismissEntityEmailsSync
  | typeof fetchEntityEmailSync
  | typeof initEntityEmails
  | typeof loadChildEmails
  | typeof loadParentEmailThreads
  | typeof loadSentEmail
  | typeof openParentEmailThread
  | typeof refreshParentEmailThread
  | typeof relateEmailEntities
  | typeof searchParentEmailThreads
  | typeof setParentEmailThreadsFolder
  | typeof unrelateEmailEntities
  | typeof updatePersonEmail
>;
